import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Feature } from '../motion/features/Feature.mjs';
import { hover } from 'motion-dom';
import { extractEventInfo } from '../events/event-info.mjs';
import { frame } from '../frameloop/frame.mjs';
function handleHoverEvent(node, event, lifecycle) {
  var props = node.props;
  if (node.animationState && props.whileHover) {
    node.animationState.setActive("whileHover", lifecycle === "Start");
  }
  var eventName = "onHover" + lifecycle;
  var callback = props[eventName];
  if (callback) {
    frame.postRender(function () {
      return callback(event, extractEventInfo(event));
    });
  }
}
var HoverGesture = /*#__PURE__*/function (_Feature) {
  function HoverGesture() {
    _classCallCheck(this, HoverGesture);
    return _callSuper(this, HoverGesture, arguments);
  }
  _inherits(HoverGesture, _Feature);
  return _createClass(HoverGesture, [{
    key: "mount",
    value: function mount() {
      var _this = this;
      var current = this.node.current;
      if (!current) return;
      this.unmount = hover(current, function (startEvent) {
        handleHoverEvent(_this.node, startEvent, "Start");
        return function (endEvent) {
          return handleHoverEvent(_this.node, endEvent, "End");
        };
      });
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);
export { HoverGesture };